/**
 * MoMent — LA DATE ET L'HEURE « À L'INSTANT », module pur (RQ, 14/10/2026).
 *
 * Quand on coche la personne jointe dans l'appel au prescripteur, la date du jour et l'heure à l'instant se remplissent d'office :
 * c'est le moment de l'appel, on ne retape rien. Heure LOCALE de la machine (le laboratoire est à Monastir) — jamais
 * `toISOString()`, qui donne l'UTC : à 00 h 30 à Tunis, la date UTC est celle de la veille.
 */
const deux = (n: number) => String(n).padStart(2, '0');

/** `{ date: '2026-10-14', heure: '10:53' }` — les formats des champs `<input type="date">` et `<input type="time">`. */
export function dateHeureLocales(d: Date = new Date()): { date: string; heure: string } {
  return { date: `${d.getFullYear()}-${deux(d.getMonth() + 1)}-${deux(d.getDate())}`, heure: `${deux(d.getHours())}:${deux(d.getMinutes())}` };
}

/** Remplit la date et l'heure QUAND ELLES SONT VIDES — jamais par-dessus ce que la personne a saisi ou corrigé. */
export function avecInstant<T extends { date: string; heure: string }>(appel: T, d: Date = new Date()): T {
  const m = dateHeureLocales(d);
  return { ...appel, date: appel.date || m.date, heure: appel.heure || m.heure };
}
